import { Directive, ElementRef, Input, OnChanges, SimpleChanges, TemplateRef } from '@angular/core';
import { escapeHTML } from './value-utils';

@Directive({
  selector: '[ngItemLabel]',
  standalone: false,
})
export class NgItemLabelDirective implements OnChanges {
  @Input() ngItemLabel: string;
  @Input() escape = true;

  constructor(private element: ElementRef<HTMLElement>) {}

  ngOnChanges(changes: SimpleChanges) {
    this.element.nativeElement.innerHTML = this.escape
      ? escapeHTML(this.ngItemLabel)
      : this.ngItemLabel;
  }
}

@Directive({
  selector: '[ng-option-tmp]',
  standalone: false,
})
export class NgOptionTemplateDirective {
  constructor(public template: TemplateRef<any>) {}
}

@Directive({
  selector: '[ng-optgroup-tmp]',
  standalone: false,
})
export class NgOptgroupTemplateDirective {
  constructor(public template: TemplateRef<any>) {}
}

@Directive({
  selector: '[ng-label-tmp]',
  standalone: false,
})
export class NgLabelTemplateDirective {
  constructor(public template: TemplateRef<any>) {}
}

@Directive({
  selector: '[ng-multi-label-tmp]',
  standalone: false,
})
export class NgMultiLabelTemplateDirective {
  constructor(public template: TemplateRef<any>) {}
}

@Directive({
  selector: '[ng-header-tmp]',
  standalone: false,
})
export class NgHeaderTemplateDirective {
  constructor(public template: TemplateRef<any>) {}
}

@Directive({
  selector: '[ng-footer-tmp]',
  standalone: false,
})
export class NgFooterTemplateDirective {
  constructor(public template: TemplateRef<any>) {}
}

@Directive({
  selector: '[ng-notfound-tmp]',
  standalone: false,
})
export class NgNotFoundTemplateDirective {
  constructor(public template: TemplateRef<any>) {}
}

@Directive({
  selector: '[ng-typetosearch-tmp]',
  standalone: false,
})
export class NgTypeToSearchTemplateDirective {
  constructor(public template: TemplateRef<any>) {}
}

@Directive({
  selector: '[ng-loadingtext-tmp]',
  standalone: false,
})
export class NgLoadingTextTemplateDirective {
  constructor(public template: TemplateRef<any>) {}
}

@Directive({
  selector: '[ng-tag-tmp]',
  standalone: false,
})
export class NgTagTemplateDirective {
  constructor(public template: TemplateRef<any>) {}
}

@Directive({
  selector: '[ng-loadingspinner-tmp]',
  standalone: false,
})
export class NgLoadingSpinnerTemplateDirective {
  constructor(public template: TemplateRef<any>) {}
}
